import axios from "axios";
import {
  ResponseItem,
  ResponseList,
  ResponseRemove,
} from "../../models/clientModels/interfaces/Response";
import * as Params from "../../models/clientModels/interfaces/apiParams";
import {
  WOStatistics2,
  statisticsItem2ListParams,
} from "../../models/serverModels/workOrder/WOStatistics2";

const rootApi = process.env.REACT_APP_API_KEY;

const statisticsItem2 = axios.create({
  baseURL: rootApi,
});

export const getList = async (
  params: statisticsItem2ListParams
): Promise<ResponseList<WOStatistics2>> =>
  statisticsItem2({
    url: "/GetStatistics2List",
    method: "get",
    params,
  }).then((res) => res.data);

export const create = async (
  params: Params.Create<WOStatistics2>
): Promise<ResponseItem<WOStatistics2>> =>
  statisticsItem2({
    url: `/statistics2`,
    method: "post",
    data: params,
  }).then((res) => res.data);

export const remove = async (params: Params.Remove): Promise<ResponseRemove> =>
  statisticsItem2({
    url: `/statistics2/${params.id}`,
    method: "delete",
    data: params,
  }).then((res) => res.data);

export const update = async (
  params: Params.Update<WOStatistics2>
): Promise<ResponseItem<WOStatistics2>> =>
  statisticsItem2({
    url: `/statistics2/${params.id}`,
    method: "put",
    data: params,
  }).then((res) => res.data);
